/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface ColaborationHistoryDTO
 */
export interface ColaborationHistoryDTO {
	/**
	 *
	 * @type {string}
	 * @memberof ColaborationHistoryDTO
	 */
	id?: string;
	/**
	 *
	 * @type {string}
	 * @memberof ColaborationHistoryDTO
	 */
	colaborationType?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof ColaborationHistoryDTO
	 */
	description?: string | null;
	/**
	 *
	 * @type {Date}
	 * @memberof ColaborationHistoryDTO
	 */
	from?: Date;
	/**
	 *
	 * @type {Date}
	 * @memberof ColaborationHistoryDTO
	 */
	to?: Date;
	/**
	 *
	 * @type {string}
	 * @memberof ColaborationHistoryDTO
	 */
	facultyId?: string;
	/**
	 *
	 * @type {string}
	 * @memberof ColaborationHistoryDTO
	 */
	companyId?: string;
}

export function ColaborationHistoryDTOFromJSON(
	json: any
): ColaborationHistoryDTO {
	return ColaborationHistoryDTOFromJSONTyped(json, false);
}

export function ColaborationHistoryDTOFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): ColaborationHistoryDTO {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		id: !exists(json, "id") ? undefined : json["id"],
		colaborationType: !exists(json, "colaborationType")
			? undefined
			: json["colaborationType"],
		description: !exists(json, "description") ? undefined : json["description"],
		from: !exists(json, "from") ? undefined : new Date(json["from"]),
		to: !exists(json, "to") ? undefined : new Date(json["to"]),
		facultyId: !exists(json, "facultyId") ? undefined : json["facultyId"],
		companyId: !exists(json, "companyId") ? undefined : json["companyId"],
	};
}

export function ColaborationHistoryDTOToJSON(
	value?: ColaborationHistoryDTO | null
): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		id: value.id,
		colaborationType: value.colaborationType,
		description: value.description,
		from: value.from === undefined ? undefined : value.from.toISOString(),
		to: value.to === undefined ? undefined : value.to.toISOString(),
		facultyId: value.facultyId,
		companyId: value.companyId,
	};
}
